<form [formGroup]="registrationFormGroup" (ngSubmit)="onSubmit()" *ngIf="this.fetchIpLocation && this.fillFormData">
  <div #planDetails class="row">
    <div class="col-sm-12 ps-0">
      <h6 class="section-heading">1. Account Details</h6>
    </div>
  </div>

  <div class="mt-2 d-flex flex-column gap-3">

    <div class="plan-row row">
      <div class="form-group col-sm-4">
        <label for="Email">Work Email: <span class="text-danger">*</span></label>
      </div>

      <div class="form-group col-sm-8">
        <input #newUserWorkEmail formControlName="email" type="email" maxlength="128" id="Email" name="Email" placeholder="Enter Email"
          [readonly]="isEditing || readOnlyUserEmailField" class="form-control form-control-sm login-email" [class]="isEditing ? 'shadow-none':''"
          [ngClass]="{'is-invalid':isSubmitted && registrationForm.email?.invalid}" autocomplete="off" />
        <span *ngIf="!(registrationForm.email?.invalid && isSubmitted)" class="text-muted">Verification email will be sent here.</span>

        <div class="text-danger" *ngIf="registrationForm.email?.invalid && isSubmitted">
          <div *ngIf="registrationForm.email?.errors | firstError : registrationForm.email?.errors?.invalidEmail">Invalid Email Format</div>
          <div *ngIf="registrationForm.email?.errors | firstError : registrationForm.email?.errors?.required"> Work Email is Required </div>
          <div *ngIf="registrationForm.email?.errors | firstError : registrationForm.email?.errors?.pattern"> Work Email must be in valid format </div>
          <div *ngIf="registrationForm.email?.errors | firstError : registrationForm.email?.errors?.maxlength"> Work mail must be less than {{registrationForm.email?.errors?.maxlength?.requiredLength}} characters </div>
        </div>
      </div>
    </div>

    <div class="plan-row row" *ngIf="!showPassword">
      <div class="form-group col-sm-4">
        <label>Password:<span class="text-danger">*</span></label>
      </div>
      <div class="form-group col-sm-8">
        <a routerLink="" (click)="resetPassword()" class="btn-link">Reset Password</a>
      </div>
    </div>

    <div class="plan-row row" *ngIf="showPassword">

      <div class="form-group col-sm-4">
        <label for="Password">Password: <span class="text-danger">*</span></label>
      </div>

      <div class="form-group col-sm-8">

        <div class="input-group">
          <input (input)="onPasswordInput()" [type]="passwordShow ? 'text' : 'password'" name="Password"
            class="form-control form-control-sm" id="Password" [class]="isEditing ? 'shadow-none':''"
            formControlName="password" placeholder="Enter Password" minlength="8" [readonly]="isFormReadOnly"
            [ngClass]="{'is-invalid':isSubmitted && registrationForm.password?.invalid}" autocomplete="off">

          <div (click)="togglePasswordVisibility('passwordShow')"
            class="pointer input-group-addon d-flex align-items-center px-2 border border-secondary border-left-0 bg-light-grey showPasswordBox">
            <i class="fa pointer" [ngClass]="passwordShow === false ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
          </div>
        </div>

        <div class="text-danger" *ngIf="registrationForm.password?.invalid && (editedOnce || isSubmitted)">
          <div *ngIf="registrationForm.password?.errors?.required">Password is required</div>
          <div *ngIf="registrationForm.password?.errors?.minlength">Password must be at least 8 characters long</div>
          <div *ngIf="registrationForm.password?.errors?.maxlength">Password must be maximum 100 characters</div>
          <div *ngIf="registrationForm.password?.errors?.pattern">Password must contain at least One Uppercase, One Lowercase and One Number</div>
        </div>
      </div>
    </div>

    <div class="plan-row row" *ngIf="showPassword">

      <div class="form-group col-sm-4">
        <label for="ConfirmPassword">Confirm Password: <span class="text-danger">*</span></label>
      </div>

      <div class="form-group col-sm-8">

        <div class="input-group">
          <input (input)="onConfirmPasswordInput()" [type]="passwordConfirmShow ? 'text' : 'password'"
            name="ConfirmPassword" class="form-control form-control-sm" id="ConfirmPassword"
            [class]="isEditing ? 'shadow-none':''" formControlName="confirmPassword" placeholder="Confirm Password"
            [readonly]="isFormReadOnly" [ngClass]="{'is-invalid':isSubmitted && registrationForm.confirmPassword?.invalid}"
            autocomplete="off">

          <div (click)="togglePasswordVisibility('passwordConfirmShow')"
            class="pointer input-group-addon d-flex align-items-center px-2 border border-secondary border-left-0 bg-light-grey passwordShowBox">
            <i class="fa pointer" [ngClass]="passwordConfirmShow === false ? 'fa-eye-slash' : 'fa-eye'"
              aria-hidden="true"></i>
          </div>
        </div>
        <div class="text-danger" *ngIf="registrationForm.confirmPassword?.invalid && (editedOnce || isSubmitted)">
          <div *ngIf="registrationForm.confirmPassword?.errors?.required">Password confirmation is required</div>
          <div *ngIf="registrationForm.confirmPassword?.errors?.confirmedValidator">Password and Confirm Password does not match</div>
        </div>
      </div>
    </div>

    <div class="plan-row row">
      <div class="form-group col-sm-4">
        <label for="FirstName">First Name: <span class="text-danger">*</span></label>
      </div>
      <div class="form-group col-sm-8">
        <input type="text" name="FirstName" class="form-control form-control-sm" id="FirstName"
          [class]="isEditing ? 'shadow-none':''" formControlName="firstName" placeholder="Enter First Name"
          [readonly]="isFormReadOnly" [ngClass]="{'is-invalid':isSubmitted && registrationForm.firstName?.invalid}" autocomplete="off">
        <div class="text-danger" *ngIf="registrationForm.firstName?.invalid && isSubmitted">
          <div *ngIf="registrationForm.firstName?.errors | firstError : registrationForm.firstName?.errors?.required ">
            First Name is required with at least 3 characters
          </div>
          <div *ngIf=" registrationForm.firstName?.errors | firstError : registrationForm.firstName?.errors?.pattern">
            First Name must only contain alphabets
          </div>
          <div *ngIf="(registrationForm.firstName?.errors | firstError : registrationForm.firstName?.errors?.maxlength)">
            First Name must not be more than {{registrationForm.firstName?.errors?.maxlength?.requiredLength}} characters
          </div>
          <div *ngIf=" registrationForm.firstName?.errors | firstError : registrationForm.firstName?.errors?.minlength">
            First Name must not be less than {{registrationForm.firstName?.errors?.minlength?.requiredLength}} characters
          </div>
        </div>
      </div>
    </div>

    <div class="plan-row row">
      <div class="form-group col-sm-4">
        <label for="LastName">Last Name: <span class="text-danger">*</span></label>
      </div>
      <div class="form-group col-sm-8">
        <input type="text" name="LastName" class="form-control form-control-sm" id="LastName" formControlName="lastName"
          placeholder="Enter Last Name" [readonly]="isFormReadOnly" [class]="isEditing ? 'shadow-none':''"
          [ngClass]="{'is-invalid':isSubmitted && registrationForm.lastName?.invalid}" autocomplete="off">
        <div class="text-danger" *ngIf="registrationForm.lastName?.invalid && isSubmitted">
          <div *ngIf="registrationForm.lastName?.errors | firstError : registrationForm.lastName?.errors?.required">
            Last Name is required with at least 3 characters
          </div>
          <div *ngIf="registrationForm.lastName?.errors | firstError : registrationForm.lastName?.errors?.pattern">
            Last Name must only contain alphabets
          </div>
          <div *ngIf="registrationForm.lastName?.errors | firstError : registrationForm.lastName?.errors?.maxlength">
            Last Name must not be more than {{registrationForm.lastName?.errors?.maxlength?.requiredLength}} characters
          </div>
          <div *ngIf="registrationForm.lastName?.errors | firstError : registrationForm.lastName?.errors?.minlength">
            Last Name must not be less than {{registrationForm.lastName?.errors?.minlength?.requiredLength}} characters
          </div>
        </div>
      </div>
    </div>

    <div class="plan-row row">
      <div class="form-group col-sm-4">
        <label for="JobTitle">Job Title: <span class="text-danger">*</span></label>
      </div>
      <div class="form-group col-sm-8">
        <input type="text" name="JobTitle" class="form-control form-control-sm" id="JobTitle" formControlName="jobTitle"
          [ngClass]="{'is-invalid':isSubmitted && registrationForm.jobTitle?.invalid}" [readonly]="isFormReadOnly"
          [class]="isEditing ? 'shadow-none':''" placeholder="Enter Job Title" autocomplete="off">
        <div class="text-danger" *ngIf="registrationForm.jobTitle?.invalid && isSubmitted">
          <div *ngIf="registrationForm.jobTitle?.errors | firstError : registrationForm.jobTitle?.errors?.required">
            Job Title is Required
          </div>
          <div *ngIf="registrationForm.jobTitle?.errors | firstError : registrationForm.jobTitle?.errors?.maxlength">
            Job Title must not be more than {{registrationForm.jobTitle?.errors?.maxlength?.requiredLength}} characters
          </div>
        </div>
      </div>
    </div>

    <div class="plan-row row">
      <div class="form-group col-sm-4">
        <label for="LastName">Work Phone: <span class="text-danger">*</span></label>
      </div>
      <div class="form-group col-sm-8">
        <div class="row">
          <div class="form-group col-sm-3">
            <ng-select [clearable]='false' [selectOnTab]='true' formControlName="countryCode" name="CountryCode"
              id="CountryCode" [readonly]="isFormReadOnly"
              [ngClass]="{'is-invalid':isSubmitted && registrationForm.countryCode?.invalid}">
              <ng-option [disabled]="isFormReadOnly" *ngFor="let cc of CountryCodes; let first = first;"

                [value]="cc">+{{cc}}</ng-option>
            </ng-select>
            <div class="text-danger" *ngIf="(registrationForm.countryCode?.invalid || registrationForm.countryCode?.value === '') && isSubmitted">
              <div
                *ngIf="(registrationForm.countryCode?.errors | firstError : registrationForm.countryCode?.errors?.required ) || registrationForm.countryCode?.value === ''">
                Country Code is Required
              </div>
              <div
                *ngIf="(registrationForm.countryCode?.errors | firstError : registrationForm.countryCode?.errors?.min) || registrationForm.countryCode?.errors?.max">
                Country Code is invalid
              </div>
            </div>
            <label class="text-muted" for="CountryCode">Country Code <span class="text-danger">*</span></label>
          </div>
          <div class="form-group col-sm-3">
            <input type="text" name="AreaCode" class="form-control form-control-sm" id="AreaCode"
              [class]="isEditing ? 'shadow-none':''" formControlName="areaCode" placeholder=""
              [ngClass]="{'is-invalid':isSubmitted && registrationForm.areaCode?.invalid}" [readonly]="isFormReadOnly"
              autocomplete="off">
            <div class="text-danger" *ngIf="registrationForm.areaCode?.invalid && isSubmitted">
              <div *ngIf="registrationForm.areaCode?.errors | firstError : registrationForm.areaCode?.errors?.required">
                Area Code is Required
              </div>
              <div *ngIf="registrationForm.areaCode?.errors | firstError : registrationForm.areaCode?.errors?.pattern">
                Area Code must only contain numerics
              </div>
              <div *ngIf="registrationForm.areaCode?.errors | firstError : registrationForm.areaCode?.errors?.maxlength">
                Area Code must not be more than {{registrationForm.areaCode?.errors?.maxlength?.requiredLength}} digits
              </div>
              <div *ngIf="registrationForm.areaCode?.errors | firstError : registrationForm.areaCode?.errors?.minlength">
                Area Code must not be less than {{registrationForm.areaCode?.errors?.minlength?.requiredLength}} digits
              </div>
            </div>
            <label class="text-muted" for="AreaCode">Area Code</label>
          </div>
          <div class="form-group col-sm-6">
            <input type="text" name="PhoneNumber" class="form-control form-control-sm" id="PhoneNumber" placeholder=""
              [ngClass]="{'is-invalid':isSubmitted && registrationForm.phoneNumber?.invalid}" [readonly]="isFormReadOnly"
              [class]="isEditing ? 'shadow-none':''" formControlName="phoneNumber">
            <div class="text-danger" *ngIf="isSubmitted" autocomplete="off">
              <div *ngIf="registrationForm.phoneNumber?.errors | firstError : registrationForm.phoneNumber?.errors?.required ">
                Phone Number is Required
              </div>
              <div *ngIf="registrationForm.phoneNumber?.errors | firstError : registrationForm.phoneNumber?.errors?.pattern">
                Phone Number must only contain numerics
              </div>
              <div *ngIf="registrationForm.phoneNumber?.errors | firstError : registrationForm.phoneNumber?.errors?.inValidPhone">
                Phone number entered in invalid
              </div>
              <div *ngIf="registrationForm.phoneNumber?.errors | firstError : registrationForm.phoneNumber?.errors?.maxlength">
                Phone number must not be more than {{registrationForm?.phoneNumber?.errors?.maxlength?.requiredLength}}
              </div>
            </div>
            <label class="text-muted" for="PhoneNumber">Phone Number <span class="text-danger">*</span></label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-sm-12 ps-2">
      <h6 class="section-heading">2. Company Details</h6>
    </div>
  </div>
  <div class="row mt-2">
    <div class="form-group col-sm-4">
      <label for="Company">Company Name: <span class="text-danger">*</span></label>
    </div>
    <div class="form-group col-sm-8">
      <input type="text" name="Company" class="form-control form-control-sm" id="Company"
        [class]="isEditing ? 'shadow-none':''" formControlName="company" placeholder="Enter Company"
        [readonly]="isEditing" [ngClass]="{'is-invalid': isSubmitted && registrationForm.company?.invalid}" autocomplete="off">
      <div class="text-danger" *ngIf="isSubmitted && registrationForm.company?.invalid">
        <div *ngIf="registrationForm.company?.errors | firstError : registrationForm.company?.errors?.required">
          Company Name is Required
        </div>
        <div *ngIf="registrationForm.company?.errors | firstError : registrationForm.company?.errors?.maxlength">
          Company Name must not be more than {{registrationForm.company?.errors?.maxlength?.requiredLength}} characters
        </div>
        <div *ngIf="registrationForm.company?.errors | firstError : registrationForm.company?.errors?.minlength">
          Company Name must not be less than {{registrationForm.company?.errors?.minlength?.requiredLength}} characters
        </div>
        <div *ngIf="registrationForm.company?.errors | firstError : registrationForm.company?.errors?.specialCharactersDisallowed">
         Comapny Name cannot contain following special characters {{getDisallowedSpecialCharacters()}}
        </div>
      </div>
      <div class="text-danger" *ngIf="registrationForm.company?.invalid">
        <div *ngIf="registrationForm.company?.errors | firstError : registrationForm.company?.errors?.notUnique">
          Company Name is already registered
        </div>
      </div>

    </div>
  </div>
  <div class="plan-row row mt-3">

    <div class="form-group col-sm-4">
      <label for="LastName">Address: <span class="text-danger">*</span></label>
    </div>

    <div class="form-group col-sm-8">

      <ng-select [clearable]='false' [selectOnTab]='true' name="CompanyAddressCountry" id="CompanyAddressCountry"
        formControlName="companyAddressCountry" [readonly]="isFormReadOnly"
        [ngClass]="{'is-invalid':isSubmitted && registrationForm.CompanyAddressCountry?.invalid}">
        <ng-option value='' disabled>Select a Country</ng-option>
        <ng-option [disabled]="isFormReadOnly" *ngFor="let countryName of CountryNames" [value]="countryName.key">
          {{countryName.value}}
        </ng-option>
      </ng-select>
      <div class="text-danger" *ngIf="registrationForm.companyAddressCountry?.invalid || registrationForm.companyAddressCountry?.value === ''">
        <div
          *ngIf="((registrationForm.companyAddressCountry?.errors | firstError : registrationForm.companyAddressCountry?.errors?.required) || registrationForm.companyAddressCountry?.value === '') && isSubmitted">
          Country is Required
        </div>
      </div>
      <label class="text-muted mt-1" for="CountryCode">Country <span class="text-danger">*</span></label>
      <br />
      <br />

      <input type="text" class="form-control form-control-sm" placeholder="Address" name="CompanyAddressLineOne"
        [class]="isEditing ? 'shadow-none':''" id="CompanyAddressLineOne" formControlName="companyAddressLineOne"
        [readonly]="isFormReadOnly" [ngClass]="{'is-invalid':isSubmitted && registrationForm.companyAddressLineOne?.invalid}" />

      <div class="text-danger" *ngIf="registrationForm.companyAddressLineOne?.invalid && isSubmitted">
        <div *ngIf="registrationForm.companyAddressLineOne?.errors | firstError : registrationForm.companyAddressLineOne?.errors?.required">
          Address is Required
        </div>
        <div
          *ngIf="registrationForm.companyAddressLineOne?.errors | firstError : registrationForm.companyAddressLineOne?.errors?.containsSpecialCharactersOnly">
          Address cannot contain special characters
        </div>
        <div *ngIf="registrationForm.companyAddressLineOne?.errors | firstError : registrationForm.companyAddressLineOne?.errors?.maxlength">
          Address must not be more than {{registrationForm.companyAddressLineOne?.errors?.maxlength?.requiredLength}} characters
        </div>
      </div>
      <label class="text-muted mt-1" for="CountryCode">Address <span class="text-danger">*</span></label>

      <div class="row mt-3">

        <div class="form-group col-sm-4">
          <input type="text" class="form-control form-control-sm" name="CompanyAddressCity" id="CompanyAddressCity"
            [class]="isEditing ? 'shadow-none':''" formControlName="companyAddressCity" [readonly]="isFormReadOnly"
            [ngClass]="{'is-invalid':isSubmitted && registrationForm.companyAddressCity?.invalid}">
          <div class="text-danger"
            *ngIf="(registrationForm.companyAddressCity?.invalid || registrationForm.companyAddressCity?.value === '') && isSubmitted">
            <div
              *ngIf="((registrationForm.companyAddressCity?.errors | firstError : registrationForm.companyAddressCity?.errors?.required) || registrationForm.companyAddressCity?.value === '')">
              City is Required
            </div>
            <div *ngIf="(registrationForm.companyAddressCity?.errors | firstError : registrationForm.companyAddressCity?.errors?.pattern)">
              City name must only contain alphanumeric characters
            </div>
            <div *ngIf="registrationForm.companyAddressCity?.errors | firstError : registrationForm.companyAddressCity?.errors?.maxlength">
              City name must not be more than {{registrationForm.companyAddressCity?.errors?.maxlength?.requiredLength}} characters
            </div>
          </div>
          <label class="text-muted mt-1" for="CountryCode">City <span class="text-danger">*</span></label>
        </div>

        <div class="form-group col-sm-4">

          <input *ngIf='registrationForm.companyAddressCountry?.value != "United States" && registrationForm.companyAddressCountry?.value != "Canada"'
            type="text" name="CompanyAddressState" id="CompanyAddressState" formControlName="companyAddressState"
            class="form-control form-control-sm" [readonly]="isFormReadOnly" [class]="isEditing ? 'shadow-none':''"
            [ngClass]="{'is-invalid':isSubmitted && registrationForm.CompanyAddressState?.invalid}">

          <select class="form-control form-control-sm" name="CompanyAddressState" id="CompanyAddressState"
            formControlName="companyAddressState"
            *ngIf='(registrationForm.companyAddressCountry?.value === "United States" || registrationForm.companyAddressCountry?.value === "Canada")'
            [ngClass]="{'is-invalid':isSubmitted && registrationForm.CompanyAddressState?.invalid}">
            <option [ngValue]="null" disabled>State/Province </option>
            <optgroup label="U.S. States/Territories" *ngIf='registrationForm.companyAddressCountry?.value === "United States"'>
              <option *ngFor="let state of USAStates" [ngValue]="state.key">
                {{state.value}}
              </option>
            </optgroup>
            <optgroup label="Canadian Provinces" *ngIf='registrationForm.companyAddressCountry?.value === "Canada"'>
              <option *ngFor="let state of CanadaStates" [ngValue]="state.key">
                {{state.value}}
              </option>
            </optgroup>
          </select>

          <div class="text-danger"
            *ngIf="(registrationForm.companyAddressState?.invalid || registrationForm.companyAddressState?.value === '') && isSubmitted">
            <div
              *ngIf="((registrationForm.companyAddressState?.errors | firstError : registrationForm.companyAddressState?.errors?.required) || registrationForm.companyAddressState?.value === '')">
              State/Province is Required
            </div>
            <div
              *ngIf="(registrationForm.companyAddressState?.errors | firstError : registrationForm.companyAddressState?.errors?.containsSpecialCharactersOnly)">
              State/Province cannot contain special characters
            </div>
            <div *ngIf="registrationForm.companyAddressState?.errors | firstError : registrationForm.companyAddressState?.errors?.pattern">
              State/Province must only contain alpha characters
            </div>
            <div *ngIf="registrationForm.companyAddressState?.errors | firstError : registrationForm.companyAddressState?.errors?.maxlength">
              State/Province must not be more than {{registrationForm.companyAddressState?.errors?.maxlength?.requiredLength}} characters
            </div>
            <div *ngIf="registrationForm.companyAddressState?.errors | firstError : registrationForm.companyAddressState?.errors?.minlength">
              State/Province must not be less than {{registrationForm.companyAddressState?.errors?.minlength?.requiredLength}} characters
            </div>
          </div>

          <label class="text-muted mt-1" for="AreaCode">State/Province <span class="text-danger">*</span></label>

        </div>

        <div class="form-group col-sm-4">

          <input type="text" class="form-control form-control-sm" placeholder="Postal Code" [readonly]="isFormReadOnly"
            [ngClass]="{'is-invalid':isSubmitted && registrationForm.CompanyAddressPostalCode?.invalid}"
            [class]="isEditing ? 'shadow-none':''" name="CompanyAddressPostalCode" id="CompanyAddressPostalCode"
            formControlName="companyAddressPostalCode" />

          <div class="text-danger"
            *ngIf="(registrationForm.companyAddressPostalCode?.invalid || registrationForm.companyAddressPostalCode?.value === '') && isSubmitted">
            <div
              *ngIf="(registrationForm.companyAddressPostalCode?.errors?.required || registrationForm.companyAddressPostalCode?.value === '') && isSubmitted">
              Postal Code is Required
            </div>
            <div *ngIf="registrationForm.companyAddressPostalCode?.errors | firstError : registrationForm.companyAddressPostalCode?.errors?.pattern">
              Length of postal code can only be between 3 and 10 characters. And only contain alphanumeric characters and dashes.
            </div>
          </div>
          <label class="text-muted mt-1" for="PhoneNumber">Postal Code <span class="text-danger">*</span></label>
        </div>

      </div>
    </div>
  </div>

  <div class="plan-row row mt-3">
    <div class="form-group col-sm-4">
      <label for="CompanyURL">Company URL: <span class="text-danger">*</span></label>
    </div>

    <div class="form-group col-sm-8">
      <input type="text" name="CompanyUrl" class="form-control form-control-sm" id="CompanyUrl"
        formControlName="companyUrl" [ngClass]="{'is-invalid':isSubmitted && registrationForm.companyUrl?.invalid}"
        placeholder="Enter Company URL" autocomplete="off" [readonly]="isFormReadOnly">
      <div class="text-danger" *ngIf="(registrationForm.companyUrl?.invalid || registrationForm.companyUrl?.value === '') && isSubmitted">
        <div *ngIf="registrationForm.companyUrl?.errors | firstError : registrationForm.companyUrl?.errors?.required"> Company Url is Required </div>
        <div *ngIf="registrationForm.companyUrl?.errors | firstError : registrationForm.companyUrl?.errors?.pattern"> Company Url is not in correct
          format </div>
        <div *ngIf="registrationForm.companyUrl?.errors | firstError : registrationForm.companyUrl?.errors?.maxlength"> Company Url must not be more
          than {{registrationForm.companyUrl?.errors?.maxlength?.requiredLength}} characters </div>
      </div>
    </div>
  </div>

  <div class="mt-4">
    <div class="row">
      <div class="col-sm-12 ps-0">
        <h6 class="section-heading">3. Second Contact Details (Optional)</h6>
      </div>
    </div>
    <div class="d-flex flex-column gap-3 mt-2">
      <div class="plan-row row">
        <div class="form-group col-sm-4">
          <label for="SecondContactFirstName">First Name: </label>
        </div>
        <div class="form-group col-sm-8">
          <input type="text" name="SecondContactFirstName" class="form-control form-control-sm"
            id="SecondContactFirstName" placeholder="Enter First Name"
            [ngClass]="{'is-invalid':isSubmitted && registrationForm.secondContactFirstName?.invalid}" autocomplete="off"
            formControlName="secondContactFirstName" (input)="this.onSecondContactControlChange()">
          <div class="text-danger"
            *ngIf="(registrationForm.secondContactFirstName?.invalid || registrationForm.secondContactFirstName?.value === '') && isSubmitted">
            <div *ngIf="registrationForm.secondContactFirstName?.errors | firstError : registrationForm.secondContactFirstName?.errors?.required">
              First Name is Required
            </div>
            <div *ngIf="registrationForm.secondContactFirstName?.errors | firstError : registrationForm.secondContactFirstName?.errors?.pattern">
              First Name must only contain alpha characters
            </div>
            <div *ngIf="registrationForm.secondContactFirstName?.errors | firstError : registrationForm.secondContactFirstName?.errors?.maxlength">
              First Name must not be more than {{registrationForm.secondContactFirstName?.errors?.maxlength?.requiredLength}} characters
            </div>
            <div *ngIf="registrationForm.secondContactFirstName?.errors | firstError : registrationForm.secondContactFirstName?.errors?.minlength">
              First Name must not be less than {{registrationForm.secondContactFirstName?.errors?.minlength?.requiredLength}} characters
            </div>
          </div>
        </div>
      </div>
      <div class="plan-row row">
        <div class="form-group col-sm-4">
          <label for="SecondContactLastName">Last Name: </label>
        </div>
        <div class="form-group col-sm-8">
          <input type="text" name="SecondContactLastName" class="form-control form-control-sm"
            id="SecondContactLastName" placeholder="Enter Last Name"
            [ngClass]="{'is-invalid':isSubmitted && registrationForm.secondContactLastName?.invalid}" autocomplete="off"
            formControlName="secondContactLastName" (input)="this.onSecondContactControlChange()">
          <div class="text-danger" *ngIf="registrationForm.secondContactLastName?.invalid && isSubmitted">
            <div *ngIf="registrationForm.secondContactLastName?.errors | firstError : registrationForm.secondContactLastName?.errors?.required">
              Last Name is Required
            </div>
            <div *ngIf="registrationForm.secondContactLastName?.errors | firstError : registrationForm.secondContactLastName?.errors?.pattern">
              Last Name must only contain alpha characters
            </div>
            <div *ngIf="registrationForm.secondContactLastName?.errors | firstError : registrationForm.secondContactLastName?.errors?.maxlength">
              Last Name must not be more than {{registrationForm.secondContactLastName?.errors?.maxlength?.requiredLength}} characters
            </div>
            <div *ngIf="registrationForm.secondContactLastName?.errors | firstError : registrationForm.secondContactLastName?.errors?.minlength">
              Last Name must not be less than {{registrationForm.secondContactLastName?.errors?.minlength?.requiredLength}} characters
            </div>
          </div>
        </div>
      </div>

      <div class="plan-row row">
        <div class="form-group col-sm-4">
          <label for="SecondContactEmail">Work Email: </label>
        </div>

        <div class="form-group col-sm-8">
          <input type="email" maxlength="128" name="SecondContactEmail" class="form-control form-control-sm" id="SecondContactEmail"
            placeholder="Enter Email" [ngClass]="{'is-invalid':isSubmitted && registrationForm.secondContactEmail?.invalid}"
            autocomplete="off" formControlName="secondContactEmail" (input)="this.onSecondContactControlChange()">

          <div class="text-danger" *ngIf="registrationForm.secondContactEmail?.invalid && isSubmitted">
            <div *ngIf="registrationForm.secondContactEmail?.errors | firstError : registrationForm.secondContactEmail?.errors?.required"> Email is Required </div>
            <div *ngIf="registrationForm.secondContactEmail?.errors | firstError : registrationForm.secondContactEmail?.errors?.email"> Email must be in valid format </div>
            <div *ngIf="registrationForm.secondContactEmail?.errors | firstError : registrationForm.secondContactEmail?.errors?.emailIsSame"> Second contact's email cannot be the same as the email on your primary account </div>
            <div *ngIf="registrationForm.secondContactEmail?.errors | firstError : registrationForm.secondContactEmail?.errors?.maxlength"> Second contact's email must be less than {{registrationForm.secondContactEmail?.errors?.maxlength?.requiredLength}} characters </div>
          </div>
        </div>
      </div>

      <div class="plan-row row">
        <div class="form-group col-sm-4">
          <label>Work Phone: </label>
        </div>
        <div class="form-group col-sm-8">
          <div class="row">
            <div class="form-group col-sm-3">

              <ng-select [clearable]='false' [selectOnTab]='true' name="SecondContactCountryCode"
                id="SecondContactCountryCode"
                [ngClass]="{'is-invalid':isSubmitted && registrationForm.secondContactCountryCode?.invalid}"
                formControlName="secondContactCountryCode" (change)="this.onSecondContactControlChange()">
                <ng-option *ngFor="let cc of CountryCodes; let first = first;" [value]="cc">+{{cc}}</ng-option>
              </ng-select>
              <div class="text-danger" *ngIf="registrationForm.secondContactCountryCode?.invalid && isSubmitted">
                <div
                  *ngIf="registrationForm.secondContactCountryCode?.errors | firstError : registrationForm.secondContactCountryCode?.errors?.required">
                  Country Code is Required
                </div>
                <div *ngIf="registrationForm.secondContactCountryCode?.errors?.min || registrationForm.secondContactCountryCode?.errors?.max">
                  Country Code is invalid
                </div>
              </div>
              <label class="text-muted" for="SecondContactCountryCode">Country Code</label>
            </div>

            <div class="form-group col-sm-3">
              <input type="text" name="SecondContactAreaCode" class="form-control form-control-sm"
                id="SecondContactAreaCode" placeholder=""
                [ngClass]="{'is-invalid':isSubmitted &&  registrationForm.secondContactAreaCode?.invalid}" autocomplete="off"
                formControlName="secondContactAreaCode" (input)="this.onSecondContactControlChange()">
              <div class="text-danger" *ngIf="registrationForm.secondContactAreaCode?.invalid && isSubmitted">
                <div *ngIf="registrationForm.secondContactAreaCode?.errors?.required">
                  Area Code is Required
                </div>
                <div *ngIf="registrationForm.secondContactAreaCode?.errors?.pattern">
                  Area Code must only contain numerics
                </div>
                <div *ngIf="registrationForm.secondContactAreaCode?.errors | firstError : registrationForm.secondContactAreaCode?.errors?.maxlength">
                  Area Code must not be more than {{registrationForm.secondContactAreaCode?.errors?.maxlength?.requiredLength}} digits
                </div>
                <div *ngIf="registrationForm.secondContactAreaCode?.errors | firstError : registrationForm.secondContactAreaCode?.errors?.minlength">
                  Area Code must not be less than {{registrationForm.secondContactAreaCode?.errors?.minlength?.requiredLength}} digits
                </div>
              </div>
              <label class="text-muted" for="SecondContactAreaCode">Area Code</label>
            </div>
            <div class="form-group col-sm-6">
              <input type="text" name="SecondContactPhoneNumber" class="form-control form-control-sm"
                id="SecondContactPhoneNumber" placeholder=""
                formControlName="secondContactPhoneNumber" (input)="this.onSecondContactControlChange()">
              <div class="text-danger" *ngIf="registrationForm.secondContactPhoneNumber?.invalid && isSubmitted" autocomplete="off">
                <div
                  *ngIf="registrationForm.secondContactPhoneNumber?.errors | firstError : registrationForm.secondContactPhoneNumber?.errors?.required">
                  Phone Number is Required
                </div>
                <div
                  *ngIf="registrationForm.secondContactPhoneNumber?.errors | firstError : registrationForm.secondContactPhoneNumber?.errors?.pattern">
                  Phone Number must only contain numerics
                </div>
                <div >
                  Phone Number Entered is Not Valid
                </div>
              </div>
              <label class="text-muted" for="SecondContactPhoneNumber">Phone Number</label>
            </div>
          </div>
        </div>
      </div>
      <div class="plan-row row">
        <div class="form-group col-sm-4">
          <label for="SecondContactJobTitle">Job Title: </label>
        </div>
        <div class="form-group col-sm-8">
          <input type="text" name="SecondContactJobTitle" class="form-control form-control-sm"
            id="SecondContactJobTitle" [ngClass]="{'is-invalid':isSubmitted && registrationForm.secondContactJobTitle?.invalid}"
            placeholder="Enter Job Title" autocomplete="off" formControlName="secondContactJobTitle"
            (input)="this.onSecondContactControlChange()">
          <div class="text-danger" *ngIf="registrationForm.secondContactJobTitle?.invalid && isSubmitted">
            <div *ngIf="registrationForm.secondContactJobTitle?.errors | firstError : registrationForm.secondContactJobTitle?.errors?.required">
              Job Title is Required
            </div>
            <div *ngIf="registrationForm.secondContactJobTitle?.errors | firstError : registrationForm.secondContactJobTitle?.errors?.maxlength">
              Job Title must not be more than {{registrationForm.secondContactJobTitle?.errors?.maxlength?.requiredLength}} characters
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="form-group">
    <div class="col-sm-12 text-right pe-0 me-0">
      <button class="btn btn-primary" type="button" *ngIf="!HideButton && formEnabled">
        <fa-icon [icon]='faUserPlus'></fa-icon> Register
      </button>
      <button class="btn btn-primary" type="button" disabled="true" *ngIf="HideButton && !formEnabled"><span
          class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Registering</button>
    </div>
  </div>
</form>